import { createContext } from 'react'

const ScreenSliderContext = createContext()

export { ScreenSliderContext }
